import { FC } from "react";
import { useGlobalState } from "../../context/context";
import LoadingAnimation from "./Loading";
import styled from "@emotion/styled";
import { Modal as BaseModal } from '@mui/base/Modal';
import { Card } from "@mui/material";

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface GlobalLoadingProps {

}

const GlobalLoading: FC<GlobalLoadingProps> = () => {
    const { state } = useGlobalState();

    return (
        <Modal open={state.loading}>
            <Card>
                <LoadingAnimation loadingText="Ładowanie..."/>
            </Card>
        </Modal>
    )
}

export default GlobalLoading;